import Picture from 'components/Picture';
import {Typography} from 'components/Typography';
import {getMediaSrc} from 'core/helpers/media';
import {makeGastronomySources} from 'modules/product-card/helpers';
import {FC} from 'react';
import style from './style.module.scss';
import Link from 'components/CustomRoutingLink';

interface IProps {
    image: string;
    title: string;
    slug: string;
    categoryPath: string;
}

export const DetailedDescriptionImageCard: FC<IProps> = ({image, title, slug, categoryPath}) => {
    return (
        <Link href={`${categoryPath}/filter/food-${slug}`} className={style.main}>
            <Picture sources={makeGastronomySources(image)} src={getMediaSrc(image)} />
            <Typography className={style.title} element={'div'} variant={'label-14-r-fluid'}>
                {title}
            </Typography>
        </Link>
    );
};
